export const HERO_BANNER_CAMPAIGN = 'Peer Insights July 2023';
export const HERO_BANNER_LINK =
  'https://app.mento.co/documents/templates/d7e43406-4a1f-4d88-9fbf-b90adab3e02d';

export const SEEN_DISMISS_DAYS = 14;
